import { useTheme } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import React from 'react';

import { useMenuSectionStyles } from '../menuStyles/menuStyles';

interface MenuSectionProps {
  children?: React.ReactNode;
  className?: string;
}

export function MenuSection(props: MenuSectionProps): React.ReactElement {
  const theme = useTheme();
  const styles = useMenuSectionStyles(theme);

  return (
    <MenuItem className={`header-menu-section ${styles.root}`}>
      <ListItemText className={`header-menu-section-text ${styles.headerMenuSectionText}`}>
        <Typography component="div" variant="subtitle1">
          {props.children}
        </Typography>
      </ListItemText>
    </MenuItem>
  );
}
